import './assets/js/userGroups.js';

import './assets/css/userGroups.less';



// WEBPACK FOOTER //
// ./src/userGroups.js